import { RootErrorComponent } from "$/components/root-error-component"
import { TranslationProvider } from "$/components/translation-provider"
import { VersionGuard } from "$/components/version-guard"
import env from "$/lib/env"
import { readDeviceLanguage } from "$/lib/language-preference"
import translationQueries from "$/lib/queries/translation-queries"
import { Toaster } from "@repo/ui/components/ui/toaster"
import { QueryClient } from "@tanstack/react-query"
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router"
import React, { Suspense } from "react"

interface RouterContext {
  queryClient: QueryClient
}

const TanStackRouterDevtools =
  env.VITE_NODE_ENV === "development"
    ? React.lazy(() =>
        import("@tanstack/router-devtools")
          .then((res) => ({
            default: res.TanStackRouterDevtools,
          }))
          .catch(() => ({
            default: () => null,
          })),
      )
    : () => null

const TanStackReactQueryDevtools =
  env.VITE_NODE_ENV === "development"
    ? React.lazy(() =>
        import("@tanstack/react-query-devtools/build/modern/production.js")
          .then((d) => ({
            default: d.ReactQueryDevtools,
          }))
          .catch(() => ({
            default: () => null,
          })),
      )
    : () => null

export const Route = createRootRouteWithContext<RouterContext>()({
  // Texts load before the first render so no screen flashes raw keys
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(
      translationQueries.dictionary(readDeviceLanguage()),
    ),
  // Renders outside the TranslationProvider, so it can't assume texts loaded
  errorComponent: RootErrorComponent,
  component: () => (
    <TranslationProvider>
      <VersionGuard>
        <Outlet />
      </VersionGuard>
      <Suspense>
        <div className="hidden">
          <TanStackRouterDevtools />
          <TanStackReactQueryDevtools />
        </div>
      </Suspense>
      <Toaster />
    </TranslationProvider>
  ),
})
